/** Whether a revision or form still needs its initial template selection. */
export function canSelectRevisionTemplate(revision: {
  revisionStatus: { slug: string };
  revisionTemplate?: { slug: string } | null;
}): boolean {
  return (
    revision.revisionStatus.slug === 'accepted-by-technician' ||
    (revision.revisionStatus.slug === 'in-progress' && !revision.revisionTemplate)
  );
}
